<div class="protection-preview">
  <h2 mat-dialog-title>
    <span>Preview</span>
    <div class="subtitle">
      How this protection appears in the O2O Protection Catalog.
    </div>
  </h2>

  <mat-dialog-content>
    <mat-button-toggle-group
      [(value)]="device"
      aria-label="Preview width"
      class="protection-preview__device"
    >
      <mat-button-toggle value="mobile">
        <mat-icon>smartphone</mat-icon>
        Mobile
      </mat-button-toggle>
      <mat-button-toggle value="desktop">
        <mat-icon>desktop_windows</mat-icon>
        Desktop
      </mat-button-toggle>
    </mat-button-toggle-group>

    <div class="protection-preview__stage">
      <div
        [class.is-mobile]="device === 'mobile'"
        class="protection-preview__frame"
      >
        <details class="pp-card" open>
          <summary class="pp-card__header">
            <h4>{{ title }}</h4>
            <mat-icon class="pp-card__chevron">expand_more</mat-icon>
          </summary>

          <hr />

          <div
            [innerHTML]="description"
            class="rich-text-content pp-card__description"
          ></div>

          <hr />

          <div class="pp-card__catalogs">
            <button
              *ngFor="let name of catalogNames"
              class="pp-download"
              mat-stroked-button
              matTooltip="Downloads are disabled in preview"
              type="button"
            >
              <mat-icon>download</mat-icon>
              <span class="pp-download__label">Download - {{ name }}</span>
            </button>
            <small *ngIf="!catalogNames.length" class="pp-card__empty">
              No catalog available
            </small>
          </div>
        </details>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
